import { extend, ValidationProvider, ValidationObserver } from "vee-validate";
import { isEmpty } from "./utils";

extend("username", {
  validate(value) {
    return isEmpty(value);
  },
  computesRequired: true,
  message: "Vui lòng nhập tên đăng nhập",
});
extend("password", {
  validate(value) {
    return isEmpty(value);
  },
  computesRequired: true,
  message: "Vui lòng nhập mật khẩu",
});
extend("captcha", {
  validate(value) {
    return isEmpty(value);
  },
  computesRequired: true,
  message: "Vui lòng nhập mã xác minh",
});

export default {
  install: (Vue) => {
    Vue.component("ValidationProvider", ValidationProvider);
    Vue.component("ValidationObserver", ValidationObserver);
  },
};
